module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VII",
      "role": "doc-pagebreak",
      "title": "VII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Foreword")])]), _vm._v(" "), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("Simon J. Gathercole")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PISTLE TO THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS")])]), _vm._v(" exhorts its readers to leave behind elementary christological teaching and move on to richer fare. This is certainly a step I had to take while supervising Bobby Jamieson’s thesis, published in 2018 as the Cambridge University Press monograph "), _c('i', [_vm._v("Jesus’ Death and Heavenly Offering in Hebrews")]), _vm._v(". I was rather embarrassingly ill equipped to supervise a thesis on Hebrews, the sum total of my research on the epistle amounting to four pages in a book on preexistence. It was Bobby who introduced me to the complex debates on how Jesus’ death related to his activity in the heavenly sanctuary, in what sense Jesus could be “perfected,” and how Hebrews’ cosmology can best be understood so that we can account for all the evidence of the epistle. Bobby is undoubtedly one of the best exegetes I have known, and our meetings consisted of collegial scholarly conversations rather than a teacher spouting forth wisdom to an ignorant student. His astonishing intellectual energy is evident from the fact that he wrote a first draft of this book moonlighting during the final months of finishing his doctoral thesis.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are several points I could make about this book. Bobby’s argumentation both in the PhD monograph and this present book is characterized by logical rigor. There is no legerdemain that glides over the steps in the argument or replaces them with rhetorical bluster. The opponents, of which there are quite a few in this book, are invariably treated accurately and courteously. The marvelous footnotes demonstrate mastery of a massive body of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VIII",
      "role": "doc-pagebreak",
      "title": "VIII"
    }
  }, [_vm._v("secondary literature. The expansive range of the book also extends to "), _c('i', [_vm._v("The Lord of the Rings")]), _vm._v(", and for those who have ears to hear the allusion, "), _c('i', [_vm._v("Yes, Minister—")]), _vm._v("demonstrating that Bobby’s time in Britain was not entirely wasted. The most impressive feature of the range of material covered is its venturing into patristic territory. Most New Testament scholars (myself included) do not feel confident enough to make constructive use of Gregory of Nyssa or Cyril of Alexandria. As I would have expected, however, Bobby’s venture here is conducted intelligently and carefully, demonstrating that patristic theology provides a “grammar” that can shed light on the theological substructure of Hebrews. In discussing the analogous case of Paul, Frances Young and David Ford remark that “it is possible for someone to speak perfectly grammatically without ever consciously knowing any grammar.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Along similar lines, Bobby elucidates the way in which Hebrews makes apparently paradoxical statements best understood as expressions arising out of a particular theological grammar. This substructure is only later theorized in the theology of the church fathers and councils, but it can legitimately be regarded as already proper to Hebrews’ own theology. Such a claim that Hebrews has a sophisticated doctrinal substratum is not an anachronism: as Bobby shows, it is not merely that the epistle provides raw material out of which theology can be constructed; the author of Hebrews is also himself a theologian engaged with the question posed by Leontius of Jerusalem: “What is Christ?” ("), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("Τί ἐστὶ Χριστός;")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have already detained the reader too long with this mere shadow of the good things to come. What follows is a brilliant study that grapples seriously with the central subject matter of Scripture, and for that we can rejoice.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0